import { useState, useEffect } from 'react';
import { FinancialPeriod, getFinancialPeriods } from '../services/ticketApiService';

export function useFinancialPeriods() {
    const [periods, setPeriods] = useState<FinancialPeriod[]>([]);

    useEffect(() => {
        getFinancialPeriods().then(setPeriods);
    }, []);

    return periods;
}
